webpackJsonp([231907212017169],{

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(133);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(134);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getIterator2 = __webpack_require__(357);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(88);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(96);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(95);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _map = __webpack_require__(358);
	
	var _map2 = _interopRequireDefault(_map);
	
	exports.default = makeAsyncScript;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SCRIPT_MAP = new _map2.default();
	
	// A counter used to generate a unique id for each component that uses the function
	var idCount = 0;
	
	function makeAsyncScript(Component, scriptURL, options) {
	  options = options || {};
	  var wrappedComponentName = Component.displayName || Component.name || "Component";
	
	  var AsyncScriptLoader = function (_React$Component) {
	    (0, _inherits3.default)(AsyncScriptLoader, _React$Component);
	
	    function AsyncScriptLoader() {
	      (0, _classCallCheck3.default)(this, AsyncScriptLoader);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	      _this.state = {};
	      return _this;
	    }
	
	    AsyncScriptLoader.prototype.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
	      if (!this.__scriptLoaderID) {
	        this.__scriptLoaderID = "async-script-loader-" + idCount++;
	      }
	      return this.__scriptLoaderID;
	    };
	
	    AsyncScriptLoader.prototype.getComponent = function getComponent() {
	      return this.childComponent;
	    };
	
	    AsyncScriptLoader.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      var key = this.asyncScriptLoaderGetScriptLoaderID();
	      var _options = options,
	          globalName = _options.globalName,
	          callbackName = _options.callbackName;
	
	      if (globalName && typeof window[globalName] !== "undefined") {
	        SCRIPT_MAP.set(scriptURL, { loaded: true, observers: new _map2.default() });
	      }
	
	      if (SCRIPT_MAP.has(scriptURL)) {
	        var entry = SCRIPT_MAP.get(scriptURL);
	        if (entry && (entry.loaded || entry.errored)) {
	          this.asyncScriptLoaderHandleLoad(entry);
	          return;
	        }
	        entry.observers.set(key, function (entry) {
	          return _this2.asyncScriptLoaderHandleLoad(entry);
	        });
	        return;
	      }
	
	      var observers = new _map2.default();
	      observers.set(key, function (entry) {
	        return _this2.asyncScriptLoaderHandleLoad(entry);
	      });
	      SCRIPT_MAP.set(scriptURL, {
	        loaded: false,
	        observers: observers
	      });
	
	      var script = document.createElement("script");
	
	      script.src = scriptURL;
	      script.async = 1;
	
	      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
	        if (SCRIPT_MAP.has(scriptURL)) {
	          var mapEntry = SCRIPT_MAP.get(scriptURL);
	          var observersMap = mapEntry.observers;
	
	          for (var _iterator = observersMap, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	            var _ref;
	
	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref = _i.value;
	            }
	
	            var _ref2 = _ref,
	                obsKey = _ref2[0],
	                observer = _ref2[1];
	
	            if (func(observer)) {
	              observersMap.delete(obsKey);
	            }
	          }
	        }
	      };
	
	      if (callbackName && typeof window !== "undefined") {
	        window[callbackName] = AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded;
	      }
	
	      script.onload = function () {
	        var mapEntry = SCRIPT_MAP.get(scriptURL);
	        if (mapEntry) {
	          mapEntry.loaded = true;
	          callObserverFuncAndRemoveObserver(function (observer) {
	            if (callbackName) {
	              return false;
	            }
	            observer(mapEntry);
	            return true;
	          });
	        }
	      };
	      script.onerror = function (event) {
	        var mapEntry = SCRIPT_MAP.get(scriptURL);
	        if (mapEntry) {
	          mapEntry.errored = true;
	          callObserverFuncAndRemoveObserver(function (observer) {
	            observer(mapEntry);
	            return true;
	          });
	        }
	      };
	
	      // (old) MSIE browsers may call "onreadystatechange" instead of "onload"
	      script.onreadystatechange = function () {
	        if (_this2.readyState === "loaded") {
	          // wait for other events, then call onload if default onload hadn't been called
	          window.setTimeout(function () {
	            var mapEntry = SCRIPT_MAP.get(scriptURL);
	            if (mapEntry && mapEntry.loaded !== true) {
	              script.onload();
	            }
	          }, 0);
	        }
	      };
	
	      document.body.appendChild(script);
	    };
	
	    AsyncScriptLoader.prototype.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
	      this.setState(state, this.props.asyncScriptOnLoad);
	    };
	
	    AsyncScriptLoader.prototype.componentWillUnmount = function componentWillUnmount() {
	      // Remove tag script
	      if (options.removeOnUnmount === true) {
	        var allScripts = document.getElementsByTagName("script");
	        for (var i = 0; i < allScripts.length; i += 1) {
	          if (allScripts[i].src.indexOf(scriptURL) > -1) {
	            if (allScripts[i].parentNode) {
	              allScripts[i].parentNode.removeChild(allScripts[i]);
	            }
	          }
	        }
	      }
	      // Clean the observer entry
	      var mapEntry = SCRIPT_MAP.get(scriptURL);
	      if (mapEntry) {
	        mapEntry.observers.delete(this.asyncScriptLoaderGetScriptLoaderID());
	        if (options.removeOnUnmount === true) {
	          SCRIPT_MAP.delete(scriptURL);
	        }
	      }
	    };
	
	    AsyncScriptLoader.prototype.render = function render() {
	      var _this3 = this;
	
	      var globalName = options.globalName;
	      var _props = this.props,
	          asyncScriptOnLoad = _props.asyncScriptOnLoad,
	          childProps = (0, _objectWithoutProperties3.default)(_props, ["asyncScriptOnLoad"]);
	
	      if (globalName && typeof window !== "undefined") {
	        childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
	      }
	      return _react2.default.createElement(Component, (0, _extends3.default)({ ref: function ref(comp) {
	          _this3.childComponent = comp;
	        } }, childProps));
	    };
	
	    return AsyncScriptLoader;
	  }(_react2.default.Component);
	
	  AsyncScriptLoader.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
	  AsyncScriptLoader.propTypes = {
	    asyncScriptOnLoad: _propTypes2.default.func
	  };
	  AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded = function () {
	    var mapEntry = SCRIPT_MAP.get(scriptURL);
	    if (!mapEntry || !mapEntry.loaded) {
	      throw new Error("Script is not loaded.");
	    }
	    for (var _iterator2 = mapEntry.observers.values(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	      var _ref3;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref3 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref3 = _i2.value;
	      }
	
	      var observer = _ref3;
	
	      observer(mapEntry);
	    }
	    delete window[options.callbackName];
	  };
	
	  if (options.exposeFuncs) {
	    var _loop = function _loop() {
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) return "break";
	        _ref4 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) return "break";
	        _ref4 = _i3.value;
	      }
	
	      var funcToExpose = _ref4;
	
	      /* eslint-disable no-loop-func */
	      AsyncScriptLoader.prototype[funcToExpose] = function () {
	        var _getComponent;
	
	        return (_getComponent = this.getComponent())[funcToExpose].apply(_getComponent, arguments);
	      };
	      /* eslint-enable no-loop-func */
	    };
	
	    for (var _iterator3 = options.exposeFuncs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	      var _ref4;
	
	      var _ret = _loop();
	
	      if (_ret === "break") break;
	    }
	  }
	  return AsyncScriptLoader;
	}

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _recaptcha = __webpack_require__(339);
	
	var _recaptcha2 = _interopRequireDefault(_recaptcha);
	
	var _reactAsyncScript = __webpack_require__(320);
	
	var _reactAsyncScript2 = _interopRequireDefault(_reactAsyncScript);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var callbackName = "onloadcallback";
	var lang = typeof window !== "undefined" && window.recaptchaOptions && window.recaptchaOptions.lang ? "&hl=" + window.recaptchaOptions.lang : "";
	var URL = "https://www.google.com/recaptcha/api.js?onload=" + callbackName + "&render=explicit" + lang;
	var globalName = "grecaptcha";
	
	exports.default = (0, _reactAsyncScript2.default)(_recaptcha2.default, URL, {
	  callbackName: callbackName,
	  globalName: globalName,
	  exposeFuncs: ["getValue", "getWidgetId", "reset", "execute"]
	});

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(133);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(134);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(88);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(96);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(95);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReCAPTCHA = function (_React$Component) {
	  (0, _inherits3.default)(ReCAPTCHA, _React$Component);
	
	  function ReCAPTCHA() {
	    (0, _classCallCheck3.default)(this, ReCAPTCHA);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    _this.state = {};
	    _this.handleExpired = _this.handleExpired.bind(_this);
	    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_this);
	    return _this;
	  }
	
	  ReCAPTCHA.prototype.getValue = function getValue() {
	    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
	      return this.props.grecaptcha.getResponse(this.state.widgetId);
	    }
	    return null;
	  };
	
	  ReCAPTCHA.prototype.getWidgetId = function getWidgetId() {
	    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
	      return this.state.widgetId;
	    }
	    return null;
	  };
	
	  ReCAPTCHA.prototype.execute = function execute() {
	    var grecaptcha = this.props.grecaptcha;
	    var widgetId = this.state.widgetId;
	
	
	    if (grecaptcha && widgetId !== undefined) {
	      return grecaptcha.execute(widgetId);
	    } else {
	      this._executeRequested = true;
	    }
	  };
	
	  ReCAPTCHA.prototype.reset = function reset() {
	    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
	      this.props.grecaptcha.reset(this.state.widgetId);
	    }
	  };
	
	  ReCAPTCHA.prototype.handleExpired = function handleExpired() {
	    if (this.props.onExpired) {
	      this.props.onExpired();
	    } else if (this.props.onChange) {
	      this.props.onChange(null);
	    }
	  };
	
	  ReCAPTCHA.prototype.explicitRender = function explicitRender(cb) {
	    if (this.props.grecaptcha && this.props.grecaptcha.render && this.state.widgetId === undefined) {
	      var wrapper = document.createElement("div");
	      var id = this.props.grecaptcha.render(wrapper, {
	        sitekey: this.props.sitekey,
	        callback: this.props.onChange,
	        theme: this.props.theme,
	        type: this.props.type,
	        tabindex: this.props.tabindex,
	        "expired-callback": this.handleExpired,
	        size: this.props.size,
	        stoken: this.props.stoken,
	        badge: this.props.badge
	      });
	      this.captcha.appendChild(wrapper);
	
	      this.setState({
	        widgetId: id
	      }, cb);
	    }
	    if (this._executeRequested && this.props.grecaptcha && this.state.widgetId !== undefined) {
	      this._executeRequested = false;
	      this.execute();
	    }
	  };
	
	  ReCAPTCHA.prototype.componentDidMount = function componentDidMount() {
	    this.explicitRender();
	  };
	
	  ReCAPTCHA.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.explicitRender();
	  };
	
	  ReCAPTCHA.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.state.widgetId !== undefined) {
	      while (this.captcha.firstChild) {
	        this.captcha.removeChild(this.captcha.firstChild);
	      }
	      this.reset();
	    }
	  };
	
	  ReCAPTCHA.prototype.handleRecaptchaRef = function handleRecaptchaRef(elem) {
	    this.captcha = elem;
	  };
	
	  ReCAPTCHA.prototype.render = function render() {
	    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
	    /* eslint-disable no-unused-vars */
	    var _props = this.props,
	        sitekey = _props.sitekey,
	        onChange = _props.onChange,
	        theme = _props.theme,
	        type = _props.type,
	        tabindex = _props.tabindex,
	        onExpired = _props.onExpired,
	        size = _props.size,
	        stoken = _props.stoken,
	        grecaptcha = _props.grecaptcha,
	        badge = _props.badge,
	        childProps = (0, _objectWithoutProperties3.default)(_props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "size", "stoken", "grecaptcha", "badge"]);
	    /* eslint-enable no-unused-vars */
	
	    return _react2.default.createElement("div", (0, _extends3.default)({}, childProps, { ref: this.handleRecaptchaRef }));
	  };
	
	  return ReCAPTCHA;
	}(_react2.default.Component);
	
	exports.default = ReCAPTCHA;
	
	
	ReCAPTCHA.displayName = "ReCAPTCHA";
	ReCAPTCHA.propTypes = {
	  sitekey: _propTypes2.default.string.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  grecaptcha: _propTypes2.default.object,
	  theme: _propTypes2.default.oneOf(["dark", "light"]),
	  type: _propTypes2.default.oneOf(["image", "audio"]),
	  tabindex: _propTypes2.default.number,
	  onExpired: _propTypes2.default.func,
	  size: _propTypes2.default.oneOf(["compact", "normal", "invisible"]),
	  stoken: _propTypes2.default.string,
	  badge: _propTypes2.default.oneOf(["bottomright", "bottomleft", "inline"])
	};
	ReCAPTCHA.defaultProps = {
	  theme: "light",
	  type: "image",
	  tabindex: 0,
	  size: "normal",
	  badge: "bottomright"
	};

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.previewQuery = exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(354);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleRecaptcha = __webpack_require__(338);
	
	var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);
	
	var _classnames = __webpack_require__(57);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _browserOptimize = __webpack_require__(244);
	
	var _browserOptimize2 = _interopRequireDefault(_browserOptimize);
	
	var _Icon = __webpack_require__(14);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Blocks = __webpack_require__(34);
	
	var _Blocks2 = _interopRequireDefault(_Blocks);
	
	var _Banners = __webpack_require__(11);
	
	var _Meta = __webpack_require__(6);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactUs = function (_React$PureComponent) {
	  _inherits(ContactUs, _React$PureComponent);
	
	  function ContactUs(props) {
	    _classCallCheck(this, ContactUs);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.toggleDropdown = _this.toggleDropdown.bind(_this);
	    _this.handleChange - _this.handleChange.bind(_this);
	    _this.verify = _this.verify.bind(_this);
	
	    _this.state = {
	      message: null,
	      errors: {},
	      responseType: null,
	      isOpen: false,
	      value: "What can we help you with?"
	    };
	    return _this;
	  }
	
	  ContactUs.prototype.verify = function verify(e) {
	    e.preventDefault();
	    this.recaptcha.execute();
	  };
	
	  ContactUs.prototype.handleSubmit = function handleSubmit() {
	    var _this2 = this;
	
	    var form = new FormData(this.form);
	
	    this.setState(function (state) {
	      return _extends({}, state, {
	        errors: {}
	      });
	    });
	
	    var formEntries = (0, _browserOptimize2.default)(form, this.form);
	
	    var valid = true;
	    var errors = {};
	    formEntries.forEach(function (_ref) {
	      var key = _ref[0],
	          value = _ref[1];
	
	      if (key !== "bot-field") {
	        if (key == "name") if (!value.trim().length) {
	          errors[key] = true;
	          valid = false;
	        }
	        if (key === "email") {
	          var regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	          var test = regEx.test(value);
	          if (!test) {
	            errors[key] = true;
	            valid = false;
	          }
	        }
	        if (key == "message") if (!value.trim().length) {
	          errors[key] = true;
	          valid = false;
	        }
	      }
	    });
	
	    if (!valid) {
	      this.recaptcha.reset();
	      this.setState(function (state) {
	        return _extends({}, state, {
	          errors: errors,
	          message: "Please fill out all required fields."
	        });
	      });
	      return;
	    }
	
	    fetch(this.form.getAttribute("action"), {
	      method: "POST",
	      body: form
	    }).then(function (response) {
	      if (response.status >= 400) {
	        _this2.setState(function () {
	          return {
	            message: "There was a problem with your submission.",
	            responseType: "error"
	          };
	        });
	      }
	      _this2.setState(function () {
	        return {
	          message: "Thank you for your message!",
	          responseType: "success"
	        };
	      });
	      _this2.form.reset();
	      _this2.recaptcha.reset();
	    });
	  };
	
	  ContactUs.prototype.toggleDropdown = function toggleDropdown() {
	    this.setState({ isOpen: !this.state.isOpen });
	  };
	
	  ContactUs.prototype.handleChange = function handleChange(e) {
	    this.setState({ value: e.target.innerText });
	  };
	
	  ContactUs.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        errors = _state.errors,
	        responseType = _state.responseType,
	        message = _state.message,
	        isOpen = _state.isOpen,
	        value = _state.value;
	    var data = this.props.data;
	
	    var page = data.mortyPage;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "flex flex-column items-center mb3 mb4-l" },
	      _react2.default.createElement(_Meta2.default, { page: page }),
	      _react2.default.createElement(_Banners.BackBanner, { page: page }),
	      _react2.default.createElement(
	        "div",
	        { className: "mw-696 mh2" },
	        message && _react2.default.createElement(
	          "p",
	          {
	            className: (0, _classnames2.default)("form__message flex items-center ph1 mb1 p white bg-forest", {
	              "bg-brick": Object.keys(errors).length > 0
	            })
	          },
	          " ",
	          message
	        ),
	        _react2.default.createElement(
	          "form",
	          {
	            "data-netlify": true,
	            "data-netlify-recaptcha": true,
	            "data-netlify-honeypot": "bot-field",
	            method: "POST",
	            action: "/",
	            id: "contact-form",
	            name: "contact",
	            className: "mb2 mb3-l",
	            ref: function ref(f) {
	              _this3.form = f;
	            },
	            onSubmit: this.verify
	          },
	          _react2.default.createElement("input", { type: "hidden", name: "form-name", value: "contact" }),
	          _react2.default.createElement(
	            "span",
	            { className: "dn" },
	            _react2.default.createElement("input", { name: "bot-field" })
	          ),
	          _react2.default.createElement("input", {
	            className: (0, _classnames2.default)("form__input mb1 w-100 p", {
	              "form__error--text": errors.name
	            }),
	            name: "name",
	            placeholder: "Name",
	            "aria-labelledby": "Name"
	          }),
	          _react2.default.createElement("input", {
	            className: (0, _classnames2.default)("form__input mb1 w-100 p", {
	              "form__error--text": errors.email
	            }),
	            name: "email",
	            placeholder: "Email Address",
	            "aria-labelledby": "Email Address"
	          }),
	          _react2.default.createElement("input", {
	            className: "form__input mb1 w-100 p",
	            name: "phone",
	            placeholder: "Phone Number (optional)",
	            "aria-labelledby": "Phone Number"
	          }),
	          _react2.default.createElement("input", { type: "hidden", name: "contact-reason", value: this.state.value }),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "form__select mb1 w-100 relative p",
	              name: "contact-reason",
	              placeholder: "contact-reason",
	              value: this.state.value,
	              onClick: function onClick() {
	                _this3.toggleDropdown();
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: (0, _classnames2.default)("form__select__placeholder flex items-center grey2 relative", {
	                  "o-50": this.state.value === "What can we help you with?"
	                })
	              },
	              this.state.value
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "form__select__arrow bg-stone absolute right-0 z-2 o-100 flex justify-center" },
	              _react2.default.createElement(_Icon2.default, { path: "arrow-down" })
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: (0, _classnames2.default)("absolute list z-2 pointer", { hidden: !isOpen }) },
	              _react2.default.createElement(
	                "li",
	                {
	                  className: "flex items-center",
	                  value: "event",
	                  label: "I have a question about an event",
	                  onClick: function onClick(e) {
	                    _this3.handleChange(e);
	                  }
	                },
	                "I have a question about an event"
	              ),
	              _react2.default.createElement(
	                "li",
	                {
	                  className: "flex items-center",
	                  value: "downtown",
	                  label: "I have a question about downtown",
	                  onClick: function onClick(e) {
	                    _this3.handleChange(e);
	                  }
	                },
	                "I have a question about downtown"
	              ),
	              _react2.default.createElement(
	                "li",
	                {
	                  className: "flex items-center",
	                  value: "other",
	                  label: "other",
	                  onClick: function onClick(e) {
	                    _this3.handleChange(e);
	                  }
	                },
	                "Other"
	              )
	            )
	          ),
	          _react2.default.createElement("textarea", {
	            className: (0, _classnames2.default)("form__textarea w-100 p", {
	              "form__error--text": errors.message
	            }),
	            name: "message",
	            placeholder: "Tell us more...",
	            "aria-labelledby": "Message",
	            maxLength: "500",
	            rows: "6",
	            style: { resize: "none" }
	          }),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_reactGoogleRecaptcha2.default, {
	              ref: function ref(e) {
	                _this3.recaptcha = e;
	              },
	              sitekey: "6LfP1VcUAAAAAC_hGC5qSWnD1db4NMKogKkK1fvL",
	              onChange: this.handleSubmit,
	              size: "invisible"
	            })
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              className: "form__button bg-blue bg-ease-out b--none h-5 white w-100 ttu mt2 mt3-l",
	              "aria-labelledby": "Submit"
	            },
	            "Submit"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "contact-form__address" },
	          _react2.default.createElement(
	            "p",
	            { className: "p-bold mb0 dark" },
	            "Venture Richmond"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p mb0 grey2" },
	            "200 S 3rd St"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p mb0 grey2" },
	            "Richmond, VA 23219"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p mb0 grey2" },
	            "(",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.google.com/maps/place/Venture+Richmond/@37.539644,-77.4459797,17z/data=!3m1!4b1!4m5!3m4!1s0x89b1113e31a36161:0xb70f47780cdc70ce!8m2!3d37.539644!4d-77.4437924",
	                target: "_blank"
	              },
	              "Directions"
	            ),
	            ")"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "p mb0 grey2" },
	            "Phone: ",
	            _react2.default.createElement(
	              "a",
	              { href: "tel:8047886466" },
	              "(804)788-6466"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ContactUs;
	}(_react2.default.PureComponent);
	
	exports.default = ContactUs;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	
	var previewQuery = exports.previewQuery = "\n  query ContactUs($id: String!) {\n    mortyPage(id: { eq: $id }) {\n      route\n      title\n      subtitle\n      abstract\n      section\n      metaTitle\n      metaDescription\n      metaKeywords\n      abstractPhotoAltText\n      abstractPhotoFocalPointX\n      abstractPhotoFocalPointY\n      abstractPhoto {\n        url\n      }\n      route\n    }\n  }\n";

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = browserOptimize;
	// utility function to comepensate for lack of FormData support in Safari
	
	function getEntries(form) {
	  var elements = form.elements;
	
	  return Array.from(elements).reduce(function (arr, element) {
	    var name = element.name;
	
	    if (!name) return arr;
	    var value = element.value;
	
	    if (element.files) {
	      if (element.multiple === true) {
	        value = element.files;
	      } else {
	        value = element.files[0];
	      }
	    }
	    return [].concat(arr, [[name, value]]);
	  }, []);
	}
	
	function browserOptimize(form, formElm) {
	  if (form.entries === undefined) {
	    return getEntries(formElm);
	  }
	  return Array.from(form.entries());
	}
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-contact-us-js-0cfdd127d7267a0676a7.js